/** Default Live model (Gemini API preview). Server token callable returns the same default. */
export const GEMINI_LIVE_MODEL_DEFAULT = 'gemini-3.1-flash-live-preview';

/** Callable name in Firebase Functions (see functions/src/index.js). */
export const GEMINI_LIVE_TOKEN_CALLABLE = 'getGeminiLiveEphemeralToken';

/** Must match deployed region (URL is us-central1-PROJECT.cloudfunctions.net/...). */
export const GEMINI_LIVE_FUNCTIONS_REGION =
  process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION || 'us-central1';

/** Tool name used to bridge scripted flows to {@code onPauseDetected}. */
export const GEMINI_LIVE_SCRIPT_TOOL_NAME = 'get_next_utterance';
